module.exports = __webpack_public_path__ + "static/img/闭眼.5e2b4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/闭眼.png
// module id = Qhvo
// module chunks = 1